import * as React from "react";
import { useMessageFormatter } from "@brite-inc/ui-hooks/dist/i18n";
import { locales } from "../i18n";
import { VisuallyHidden } from "../VisuallyHidden";
import styles from "./styles.module.scss";

interface IProps {
    className?: string;
}

export function Spinner({className} :IProps) {
    const formatMessage = useMessageFormatter(locales.default);

    return (
        <div className={`${styles.spinnerContainer} ${className}`} data-testid="spinner">
            <div className={styles.spinner}>
                <div />
                <div>
                    <div />
                </div>
            </div>

            <VisuallyHidden role="status">
                {formatMessage("loading")}
            </VisuallyHidden>
        </div>
    );
}
